import { render, staticRenderFns } from "./CopyInput.vue?vue&type=template&id=6db879c3&scoped=true"
import script from "./CopyInput.vue?vue&type=script&lang=ts"
export * from "./CopyInput.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6db879c3",
  null
  
)

export default component.exports